import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { isEmpty } from 'underscore';
import { userFilterForm } from './filterForm';
import * as AssetActions from '../../../core/asset/assetActions';

class TheFilterForm extends React.Component {
    constructor(props) {
        super(props);
        this.view = userFilterForm;
    }

    componentDidMount() {
        const { actions } = this.props;
        actions.getDivisionsRequest();
    }

    handleSubmit = (e) => {
        const { form, type } = this.props;

        e.preventDefault();
        const arr = (type === 'user' ? ['name', 'email', 'status', 'role', 'divisions'] : ['divisions']);
        form.validateFieldsAndScroll(arr, (err, values) => {
            if (!err) {
                const { onSubmit } = this.props;
                onSubmit(values, type);
            }
        });
    };

    render() {
        return this.view();
    }
}

TheFilterForm.defaultProps = {
    type: 'user',
};

TheFilterForm.propTypes = {
    form: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    type: PropTypes.string,
    searchParams: PropTypes.object.isRequired,
    divisions: PropTypes.array.isRequired,
};

const FilterForm = Form.create({
    name: 'usersFilterForm',
    mapPropsToFields(props) {
        const initialData = {};
        if (!isEmpty(props.searchParams)) {
            Object.keys(props.searchParams).map((item) => {
                if (!isEmpty(item)) {
                    initialData[item] = Form.createFormField({
                        value: props.searchParams[item],
                    });
                }
            });
        }

        return initialData;
    },
})(TheFilterForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        users: state.user.users,
        departments: state.department.departments,
        searchParams: state.user.userTabFilters,
        userOptions: state.user.options,
        userTabFilters: state.filters.userTabFilters,
        divisions: state.asset.divisions,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...AssetActions,
            },
            dispatch,
        ),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterForm);
